export default "__VITE_ASSET__CkiV9B_T__"